module.exports = __webpack_public_path__ + "img/item-4.2a1e840.png";